@keyframes fadeIn {
    from {
        opacity: 0.25;
    }
    to {
        opacity: 1;
    }
}

.days {
    all: unset;
    position: relative;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 1px 1px 1px 1px;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    letter-spacing: 0.06px;
    border-radius: 4px;
    user-select: none;
    border: 2px solid transparent;
}

.roundedLeft {
    border-top-left-radius: 14px;
    border-bottom-left-radius: 14px;
}

.roundedRight {
    border-top-right-radius: 14px;
    border-bottom-right-radius: 14px;
}

@media (max-width: 768px) {
    .days {
        height: 40px;
        font-size: 15px;
    }
}

@media (max-width: 480px) {
    .days {
        height: 30px;
        font-size: 14px;
    }
}

.cursorAndHoover {
    cursor: pointer;
}

.cursorAndHoover:hover,
.cursorAndHoover:focus-visible {
    box-shadow: 0 2px 6px var(--ax-bg-overlay);
    border-color: var(--ax-bg-overlay);
}

.srOnly {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
}

.fadeIn {
    animation: fadeIn 0.5s ease-in forwards;
}

.blueDay {
    background-color: var(--ax-accent-400) !important;
    print-color-adjust: exact;
}

.darkblueDay {
    background-color: var(--ax-bg-accent-strong-pressed) !important;
    color: var(--ax-bg-default);
    print-color-adjust: exact;
}

.lightblueDay {
    background-color: var(--ax-accent-300) !important;
    border: 2px solid var(--ax-accent-500);
    print-color-adjust: exact;
}

.lightblueDay.firstDay {
    border-left: 2px solid var(--ax-accent-500);
}

.lightblueDay.lastDay {
    border-right: 2px solid var(--ax-accent-500);
}

.lightblueDay.firstAndLastDay {
    border-left: 2px solid var(--ax-accent-500);
    border-right: 2px solid var(--ax-accent-500);
}

.lightgreenDay {
    background-color: var(--ax-success-400) !important;
    border: 2px solid var(--ax-success-400);
    print-color-adjust: exact;
}

.lightgreenDay.firstDay {
    border-left: 2px solid var(--ax-success-400);
}

.lightgreenDay.lastDay {
    border-right: 2px solid var(--ax-success-400);
}

.lightgreenDay.firstAndLastDay {
    border-left: 2px solid var(--ax-success-400);
    border-right: 2px solid var(--ax-success-400);
}

.greenDay {
    background-color: var(--ax-success-400) !important;
    print-color-adjust: exact;
}

.greenStripedDay {
    background: linear-gradient(
        45deg,
        var(--ax-success-400) 0%,
        var(--ax-success-400) 15%,
        var(--ax-bg-default) 15%,
        var(--ax-bg-default) 30%,
        var(--ax-success-400) 30%,
        var(--ax-success-400) 45%,
        var(--ax-bg-default) 45%,
        var(--ax-bg-default) 60%,
        var(--ax-success-400) 60%,
        var(--ax-success-400) 75%,
        var(--ax-bg-default) 75%,
        var(--ax-bg-default) 90%,
        var(--ax-success-400) 90%
    ) !important;
    border: 2px solid var(--ax-success-500);
    print-color-adjust: exact;
}

.greenStripedDay.firstDay {
    border-left: 2px solid var(--ax-success-500);
}

.greenStripedDay.lastDay {
    border-right: 2px solid var(--ax-success-500);
}

.greenStripedDay.firstAndLastDay {
    border-left: 2px solid var(--ax-success-500);
    border-right: 2px solid var(--ax-success-500);
}

.blueStripedDay {
    background: linear-gradient(
        45deg,
        var(--ax-accent-400) 0%,
        var(--ax-accent-400) 15%,
        var(--ax-bg-default) 15%,
        var(--ax-bg-default) 30%,
        var(--ax-accent-400) 30%,
        var(--ax-accent-400) 45%,
        var(--ax-bg-default) 45%,
        var(--ax-bg-default) 60%,
        var(--ax-accent-400) 60%,
        var(--ax-accent-400) 75%,
        var(--ax-bg-default) 75%,
        var(--ax-bg-default) 90%,
        var(--ax-accent-400) 90%
    ) !important;
    border: 2px solid var(--ax-accent-500);
    print-color-adjust: exact;
}

.blueStripedDay.firstDay {
    border-left: 2px solid var(--ax-accent-500);
}

.blueStripedDay.lastDay {
    border-right: 2px solid var(--ax-accent-500);
}

.blueStripedDay.firstAndLastDay {
    border-left: 2px solid var(--ax-accent-500);
    border-right: 2px solid var(--ax-accent-500);
}

.grayDay {
    background-color: var(--ax-neutral-100);
    print-color-adjust: exact;
    cursor: default;
}

.darkgrayDay {
    background-color: var(--ax-neutral-400);
    print-color-adjust: exact;
    cursor: default;
}

.blackDay {
    background-color: var(--ax-bg-neutral-strong) !important;
    color: var(--ax-bg-default);
    print-color-adjust: exact;
}

.blackOutlineDay {
    border: 2px solid var(--ax-bg-neutral-strong);
    print-color-adjust: exact;
}

.blueOutlineDay {
    border: 2px solid var(--ax-accent-500);
    print-color-adjust: exact;
}

.beigeOutlineDay {
    border: 2px solid var(--ax-brand-beige-600);
    print-color-adjust: exact;
}

.greenWithBlackOutlineDay {
    background-color: var(--ax-success-400) !important;
    border: 2px solid var(--ax-bg-neutral-strong);
    print-color-adjust: exact;
}

.blueWithBlackOutlineDay {
    background-color: var(--ax-accent-400) !important;
    border: 2px solid var(--ax-bg-neutral-strong);
    print-color-adjust: exact;
}

.blueOutlineDay.firstDay {
    border-left: 2px solid var(--ax-accent-500);
}

.blueOutlineDay.lastDay {
    border-right: 2px solid var(--ax-accent-500);
}

.blueOutlineDay.firstAndLastDay {
    border-left: 2px solid var(--ax-accent-500);
    border-right: 2px solid var(--ax-accent-500);
}

.greenOutlineDay {
    border: 2px solid var(--ax-success-400);
    print-color-adjust: exact;
}

.greenOutlineDay.firstDay {
    border-left: 2px solid var(--ax-success-400);
}

.greenOutlineDay.lastDay {
    border-right: 2px solid var(--ax-success-400);
}

.greenOutlineDay.firstAndLastDay {
    border-left: 2px solid var(--ax-success-400);
    border-right: 2px solid var(--ax-success-400);
}

.lightgreenBlueDay {
    background: linear-gradient(
        to top,
        var(--ax-accent-400),
        var(--ax-accent-400) 50%,
        var(--ax-success-200) 50%,
        var(--ax-success-200) 75%,
        var(--ax-success-200) 100%
    ) !important;
    border: 2px solid var(--ax-accent-400);
    print-color-adjust: exact;
}

.lightgreenBlueDay.firstDay {
    border-left: 2px solid var(--ax-accent-500);
}

.lightgreenBlueDay.lastDay {
    border-right: 2px solid var(--ax-accent-500);
}

.lightgreenBlueDay.firstAndLastDay {
    border-left: 2px solid var(--ax-accent-500);
    border-right: 2px solid var(--ax-accent-500);
}

.lightblueGreenDay {
    background: linear-gradient(
        to top,
        var(--ax-success-400),
        var(--ax-success-400) 50%,
        var(--ax-accent-300) 50%,
        var(--ax-accent-300) 100%
    ) !important;
    border: 2px solid var(--ax-success-400);
    print-color-adjust: exact;
}

.lightblueGreenDay.firstDay {
    border-left: 2px solid var(--ax-success-400);
}

.lightblueGreenDay.lastDay {
    border-right: 2px solid var(--ax-success-400);
}

.lightblueGreenDay.firstAndLastDay {
    border-left: 2px solid var(--ax-success-400);
    border-right: 2px solid var(--ax-success-400);
}

.hoverPreviewDay {
    background-color: var(--ax-accent-600);
    print-color-adjust: exact;
}

.icon {
    position: absolute;
    bottom: 2px;
    right: 2px;
    width: 12px;
    height: 12px;
    pointer-events: none;
}
